module.exports = __webpack_public_path__ + "static/img/2.1bad337.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/zh/2.png
// module id = eVS5
// module chunks = 0